module.exports = __webpack_public_path__ + "static/icon-selection-c719f872b88838ecfe9f8441b6e0924d.svg";